import { render, staticRenderFns } from "./delete_modal_secrets_count.vue?vue&type=template&id=2b1c849e"
import script from "./delete_modal_secrets_count.vue?vue&type=script&lang=js"
export * from "./delete_modal_secrets_count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports